import { render, staticRenderFns } from "./SurveyModal.vue?vue&type=template&id=956c654c&"
import script from "./SurveyModal.vue?vue&type=script&lang=ts&"
export * from "./SurveyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports